module.exports = __webpack_public_path__ + "static/assets/c399212f9ed1df9720ff813360923865.png";